import React from 'react'
import {
  FormGroup,
  FormControlLabel,
  Checkbox as CheckboxMui,
} from '@material-ui/core'
import PropTypes from 'prop-types'

const Checkbox = ({
  input: { value, onChange },
  label,
  className,
}) => (
  <FormGroup row>
    <FormControlLabel
      control={
        <CheckboxMui
          checked={Boolean(value)}
          onChange={() => onChange(+!value)}
          className={className}
        />
      }
      label={label}
    />
  </FormGroup>
)

Checkbox.defaultProps = {
  className: undefined,
}

Checkbox.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default Checkbox
